import type { Invoice } from "@/lib/invoice.api";

export function getInvoiceLabel(invoice: Invoice): string {
  return invoice.number ?? `Brouillon #${invoice.id}`;
}

export function formatInvoiceAge(value: string): string {
  const created = new Date(value).getTime();
  const diffDays = Math.max(0, Math.floor((Date.now() - created) / 86_400_000));
  if (diffDays === 0) return "Aujourd'hui";
  if (diffDays === 1) return "Hier";
  return `Il y a ${diffDays} jours`;
}
